import { Tab, Tabs } from 'baseui/tabs-motion'
import PulseScope from '@/shared/components/PulseScope/PulseScope'
import { TabsFrame } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/styled-components'
import PulseTabLabel from '@/containers/SubscriptionFormPageNew/SubscriptionForm/PulseTabLabel/PulseTabLabel'
import { DashboardV2Filters } from '../types'
import FiltersPanel from './FiltersPanel/FiltersPanel'
import SearchCard from './SearchCard/SearchCard'
import ContractsCard from './ContractsCard/ContractsCard'
import useOverviewPulse from './useOverviewPulse'
import { OverviewAside, OverviewLayout, OverviewMain } from './styled-components'

interface OverviewPulseProps {
  filters: DashboardV2Filters
  providersList: Record<string, unknown>
  usersList: Record<string, unknown>
  applicationType: string
  getContracts: () => void
  formInitUrl: string
  onVerticalChange: (vertical: string) => void
}

const OverviewPulse = ({
  filters,
  providersList,
  usersList,
  applicationType,
  getContracts,
  formInitUrl,
  onVerticalChange,
}: OverviewPulseProps) => {
  const { verticals, onTabChange, tabsOverrides, tabOverrides, activeCount, canReset, resetFilters } = useOverviewPulse(
    {
      filters,
      applicationType,
      onVerticalChange,
    },
  )

  return (
    <PulseScope enabled>
      <TabsFrame $pulse>
        <Tabs activeKey={applicationType} onChange={onTabChange} overrides={tabsOverrides}>
          {verticals.map(vertical => (
            <Tab
              key={vertical.key}
              title={
                <PulseTabLabel Icon={vertical.Icon} active={vertical.active}>
                  {vertical.label}
                </PulseTabLabel>
              }
              overrides={tabOverrides}
            >
              <OverviewLayout>
                <OverviewAside>
                  <FiltersPanel
                    filters={filters}
                    applicationType={applicationType}
                    providersList={providersList}
                    usersList={usersList}
                    activeCount={activeCount}
                    onReset={resetFilters}
                  />
                </OverviewAside>
                <OverviewMain>
                  <SearchCard filters={filters} applicationType={applicationType} />
                  <ContractsCard
                    businessType={applicationType}
                    getContracts={getContracts}
                    formInitUrl={formInitUrl}
                    canReset={canReset}
                    onReset={resetFilters}
                  />
                </OverviewMain>
              </OverviewLayout>
            </Tab>
          ))}
        </Tabs>
      </TabsFrame>
    </PulseScope>
  )
}

export default OverviewPulse
